/** Audience re-evaluation: fixed at upload time vs follows group membership over time. */
export const SCHOOL_DOCUMENT_AUDIENCE_MODE = {
    static: 0,
    dynamic: 1,
};

/** When eligible students are notified about this document. */
export const SCHOOL_DOCUMENT_NOTIFICATION_MODE = {
    none: 0,
    initialOnly: 1,
    initialAndNewEligible: 2,
};

export const DEFAULT_SCHOOL_DOCUMENT_AUDIENCE_MODE = SCHOOL_DOCUMENT_AUDIENCE_MODE.dynamic;
export const DEFAULT_SCHOOL_DOCUMENT_NOTIFICATION_MODE = SCHOOL_DOCUMENT_NOTIFICATION_MODE.none;

const AUDIENCE_MODE_LABELS = {
    [SCHOOL_DOCUMENT_AUDIENCE_MODE.static]: 'Fixed when saved',
    [SCHOOL_DOCUMENT_AUDIENCE_MODE.dynamic]: 'Keeps up with groups',
};

const NOTIFICATION_MODE_LABELS = {
    [SCHOOL_DOCUMENT_NOTIFICATION_MODE.none]: 'No notifications',
    [SCHOOL_DOCUMENT_NOTIFICATION_MODE.initialOnly]: 'Once, when it first applies',
    [SCHOOL_DOCUMENT_NOTIFICATION_MODE.initialAndNewEligible]: 'First applies and new eligible',
};

export function formatSchoolDocumentAudienceMode(mode) {
    const n = mode == null ? DEFAULT_SCHOOL_DOCUMENT_AUDIENCE_MODE : Number(mode);
    return AUDIENCE_MODE_LABELS[n] ?? String(mode);
}

export function formatSchoolDocumentNotificationMode(mode) {
    const n = mode == null ? DEFAULT_SCHOOL_DOCUMENT_NOTIFICATION_MODE : Number(mode);
    return NOTIFICATION_MODE_LABELS[n] ?? String(mode);
}

export function normalizeSchoolDocumentAudienceMode(mode) {
    if (mode == null || mode === '') return DEFAULT_SCHOOL_DOCUMENT_AUDIENCE_MODE;
    const n = Number(mode);
    return n === SCHOOL_DOCUMENT_AUDIENCE_MODE.static || n === SCHOOL_DOCUMENT_AUDIENCE_MODE.dynamic
        ? n
        : DEFAULT_SCHOOL_DOCUMENT_AUDIENCE_MODE;
}

export function normalizeSchoolDocumentNotificationMode(mode) {
    if (mode == null || mode === '') return DEFAULT_SCHOOL_DOCUMENT_NOTIFICATION_MODE;
    const n = Number(mode);
    return n in NOTIFICATION_MODE_LABELS
        ? n
        : DEFAULT_SCHOOL_DOCUMENT_NOTIFICATION_MODE;
}
